// Lightweight A/B-test helper for the EN landing page.
// - Assigns each anonymous visitor a stable variant ('A' or 'B') stored in localStorage
// - Generates a stable anon_id (also localStorage) so backend can stitch landing → signup
// - Fires non-blocking tracking events to /api/ab/track
import { api } from './api';

const VARIANT_KEY = 'stillroom_ab_variant';
const ANON_ID_KEY = 'stillroom_anon_id';
const FORCE_QS = 'ab'; // ?ab=A or ?ab=B for QA

function rand4() {
    return Math.random().toString(36).slice(2, 6);
}

export function getOrAssignVariant() {
    try {
        // QS override (for sharing/QA), persisted afterwards
        const params = new URLSearchParams(window.location.search);
        const forced = (params.get(FORCE_QS) || '').toUpperCase();
        if (forced === 'A' || forced === 'B') {
            localStorage.setItem(VARIANT_KEY, forced);
            return forced;
        }
        const saved = localStorage.getItem(VARIANT_KEY);
        if (saved === 'A' || saved === 'B') return saved;
        const assigned = Math.random() < 0.5 ? 'A' : 'B';
        localStorage.setItem(VARIANT_KEY, assigned);
        return assigned;
    } catch {
        return 'A';
    }
}

export function getOrAssignAnonId() {
    try {
        const saved = localStorage.getItem(ANON_ID_KEY);
        if (saved) return saved;
        const id = `anon_${Date.now().toString(36)}_${rand4()}${rand4()}`;
        localStorage.setItem(ANON_ID_KEY, id);
        return id;
    } catch {
        return `anon_${Date.now().toString(36)}`;
    }
}

export function getVariant() {
    try { return localStorage.getItem(VARIANT_KEY) || null; } catch { return null; }
}

export function getAnonId() {
    try { return localStorage.getItem(ANON_ID_KEY) || null; } catch { return null; }
}

export async function track(event, meta) {
    const variant = getVariant();
    const anon_id = getAnonId();
    if (!variant || !anon_id) return;
    try {
        await api.post('/ab/track', {
            event,
            variant,
            anon_id,
            page: typeof window !== 'undefined' ? window.location.pathname : null,
            meta: meta || null,
        });
    } catch {
        // tracking is best-effort — never block UX
    }
}
